import { useTranslation } from 'react-i18next';

import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
} from '@/components/shadcn/field';
import { Switch } from '@/components/shadcn/switch';
import useLocalSettings from '@/stores/useLocalSettings';

export default function AutoConceptReplySetting() {
  const { t } = useTranslation();

  const { autoGenerateConceptReply, actions } = useLocalSettings();

  return (
    <Field orientation="horizontal">
      <FieldContent>
        <FieldLabel htmlFor="auto-concept-reply">
          {t('SETTINGS_AUTO_CONCEPT_REPLY')}
        </FieldLabel>

        <FieldDescription>
          {t('SETTINGS_AUTO_CONCEPT_REPLY_DESCRIPTION')}
        </FieldDescription>
      </FieldContent>

      <Switch
        id="auto-concept-reply"
        checked={autoGenerateConceptReply}
        onCheckedChange={actions.toggleAutoGenerateConceptReply}
      />
    </Field>
  );
}
